// このファイルは scripts/renewal/gen_site.py でモックアップから生成した。
// 文言・構成を直すときは、このファイルを直接編集してよい（再生成はしない）。
import { Link } from "react-router-dom";

// 各ページ末尾の「Contact」帯。ground=false で白背景（地の色が続くページ用）。
export default function ContactBand({ ground = true }) {
  return (
    <section className={`section${ground ? " ground" : ""} contact`}>
      <div className="container">
        <h2 className="contact-title">Contact</h2>
        <p className="contact-lead">
          サービスに関するご相談・ご質問は、お気軽にお問い合わせください。
        </p>
        <Link className="contact-cta" to="/contact">
          <span>無料相談</span>
          <span aria-hidden="true">→</span>
        </Link>
      </div>
    </section>
  );
}
